// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 368) return "static/chunks/368-55422d7213d368b0.js";
	if (chunkId === 327) return "static/chunks/327-c99e203cf9e13cff.js";
	if (chunkId === 80) return "static/chunks/80-b9d7698236650af2.js";
	if (chunkId === 755) return "static/chunks/755-a7ce24c03aaa35ed.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"197":"0817308e4b12c52d","422":"8d9bcc4c14220441","452":"6660fe98083de32b","522":"a5e916e683485d11","641":"7c153d1c7dc91dbb"}[chunkId] + ".js";
};